import type { ApplicationContext } from '@app/setup/shared-types'

import { consumeSegmentReadyArm } from '../utils/segment-ready'

// Listens for the generic `toast:before-show` event dispatched by the
// global toast subscriber and suppresses Insights segment-ready toasts
// the user hasn't armed (or is already viewing). Calling
// `preventDefault()` on the cancelable event tells the subscriber to
// drop the toast.
export default function setupSegmentReadyToastGate(
  appContext: ApplicationContext
): ApplicationContext {
  document.addEventListener('toast:before-show', (event: Event) => {
    const detail = (event as CustomEvent<{ payload?: Record<string, unknown> }>)
      .detail
    const payload = detail?.payload
    if (!payload) return
    if (!consumeSegmentReadyArm(window.Silverfin?.currentFirmId, payload)) {
      event.preventDefault()
    }
  })
  return appContext
}
